<template>
    <div id="footer" style="">
        <span
            class="floatleft lineheight40 margintop10"
            style="position: relative;clear: none;"
            >Vragen of hulp bij je boeking nodig? Bel dan naar
            <a href="tel:0107200500" style="font-weight:normal;"
                >010-7200500</a
            ></span
        >
        <div
            class="width44"
            style="float: right;position: relative;clear: none;"
        >
            <div class="d-flex footer-item-images" style="">
                <div class="importantimages" style="float: left;width: 140px;">
                    <span
                        class="floatleft height30 margin5 fd-img"
                        style="float: left;"
                    ></span>
                </div>
                <div class="betaalmethodes" style="">
                    <span
                        class="floatleft margin5 ideal-img"
                        style="float: left;"
                    ></span>
                    <span
                        class="floatleft margin5 paypal-img"
                        style="float: left;"
                    ></span>
                    <span
                        class="floatleft margin5 mrcash-img"
                        style="float: left;"
                    ></span>
                    <span
                        class="floatleft margin5 visa-img"
                        style="float: left;"
                    ></span>
                    <span
                        class="floatleft margin5 master-img"
                        style="float: left;"
                    ></span>
                    <span
                        class="floatleft margin5 amex-img"
                        style="float: left;"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
}
</script>

<style scoped lang="scss">
#footer {
    max-width: 1200px;
    margin: 0 auto;
    float: none !important;
    height: 40px;
    line-height: 40px;
    border-top: 1px solid rgb(239, 239, 239);
    padding-top: 15px;
    padding-bottom: 15px;
}
</style>
